// Cookie-based Supabase browser client.
//
// SECURITY (load-bearing — see netlify/edge-functions/auth-gate.ts):
// This MUST use createBrowserClient from @supabase/ssr, which stores the
// session in cookies. The Netlify edge gate reads those cookies to decide
// whether to serve the protected app chunk. If this is ever switched to
// createClient from @supabase/supabase-js (localStorage), the edge gate
// goes blind and the security model breaks. scripts/verify-chunk-split.sh
// fails the build if that happens.
import { createBrowserClient } from '@supabase/ssr';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;

if (!url || !key) {
  throw new Error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY. Set them in the marketing Netlify site env (or .env.local for vite dev).'
  );
}

export const supabase = createBrowserClient(url, key);
